import { render, staticRenderFns } from "./SuccessfulRegistration.vue?vue&type=template&id=b643d446"
import script from "./SuccessfulRegistration.vue?vue&type=script&lang=js"
export * from "./SuccessfulRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports